import * as I18n from 'circe/I18n';
import { NAME as APP_NAME, ROUTES as DRIVERS_ROUTES } from '../constants';
import * as components from './components/Form/Sections';

export const NAME = `${APP_NAME}/DRIVER`;

export const REDUCER_NAME = 'createReducer';

export const FORM_NAME = 'CREATE_DRIVER';

export const ROUTES = {
  ROOT: `${DRIVERS_ROUTES.ROOT}/create`,
};

export const SECTIONS = [
  {
    title: I18n.str('personalInformation', 'Personal Information'),
    component: components.PersonalInformation,
    name: 'personalInformation',
  },
  {
    title: I18n.str('TruckDetails', 'Truck Details'),
    component: components.TruckDetails,
    name: 'truckDetails',
  },
  {
    title: I18n.str('VehicleDocuments', 'Vehicle Documents'),
    component: components.VehicleDocuments,
    name: 'vehicleDocuments',
  },
];

export const TRUCK_TYPES = {
  VAN: {
    label: I18n.str('VAN', 'Van'),
    value: 'VAN',
  },
  STRAIGHT_TRUCK_ENCLOSED: {
    label: I18n.str('STRAIGHT_TRUCK_ENCLOSED', 'Straight truck enclosed'),
    value: 'STRAIGHT_TRUCK_ENCLOSED',
  },
  TRACTOR_TRAILER_ENCLOSED: {
    label: I18n.str('TRACTOR_TRAILER_ENCLOSED', 'Tractor trailer enclosed'),
    value: 'TRACTOR_TRAILER_ENCLOSED',
  },
  OPEN: {
    label: I18n.str('OPEN', 'Open'),
    value: 'OPEN',
  },
  DRY_BOX: {
    label: I18n.str('DRY_BOX', 'Dry box'),
    value: 'DRY_BOX',
  },
  REEFER: {
    label: I18n.str('REEFER', 'Reefer'),
    value: 'REEFER',
  },
  FLAT_BED: {
    label: I18n.str('FLAT_BED', 'Flat bed'),
    value: 'FLAT_BED',
  },
  SIDE_CURTAIN: {
    label: I18n.str('SIDE_CURTAIN', 'Side curtain'),
    value: 'SIDE_CURTAIN',
  },
  BULKER: {
    label: I18n.str('BULKER', 'Bulker'),
    value: 'BULKER',
  },
};
